module.exports = __webpack_public_path__ + "img/quizz-step-1-1.c2f83a46.jpg";